<template>
  <div class="container text-center py-3">
    <h2>Potfolio</h2>
    <div class="row mt-3">
      <div v-for="(x, idx) in portfolio" :key="idx" class="col-sm-3 p-2">
        <c-portfolio-card
          :link="x.link"
          :domain="x.domain"
          :product="x.product"
          :shortdesc="x.shortdesc"
          :img="x.img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import cPortfolioCard from "../components/cPortfolioCard.vue";
export default {
  metaInfo: {
    titleTemplate: "%s | Portfolio",
    meta: [
      {
        name: "description",
        content: "Portfolio. Primjeri nekih naših odsadašnjih projekata",
      },
    ],
  },
  components: {
    cPortfolioCard,
  },
  data() {
    return {
      portfolio: [
        {
          link: "https://www.programprehrane.com",
          domain: "programprehrane.com",
          product: "Program Prehrane Web",
          shortdesc: "Web aplikacija za nutricioniste",
          img: "ppw.png",
        },
        {
          link: "https://www.programprehrane.com/program-prehrane-5",
          domain: "programprehrane.com/program-prehrane-5",
          product: "Program Prehrane 5.0",
          shortdesc: "Računalni program za izradu uravnoteženih jelovnika",
          img: "pp5.png",
        },
        {
          link: "../kup/",
          domain: "igprog.hr/kup",
          product: "Kasa uzajamne pomoći",
          shortdesc: "Web aplikacija vođenje blagajne uzajamne pomoći",
          img: "kup.png",
        },
        {
          link: "",
          domain: "",
          product: "",
          shortdesc: "Web aplikacija za evidenciju rada teretane",
          img: "et.png",
        },
        // {
        //   link: "",
        //   domain: "",
        //   product: "Evidencija treninga",
        //   shortdesc: "Web aplikacija za sportske klubove",
        //   img: "ek.png",
        // },
        {
          link: "",
          domain: "",
          product: "Energetski pregledi",
          shortdesc: "Web aplikacija za vođenje evidencije energetskih pregleda",
          img: "energetskipregledi.png",
        },
        {
          link: "https://www.apartmentverano.com",
          domain: "apartmentverano.com",
          product: "Apartman Verano - Njivice",
          shortdesc: "Apartman",
          img: "apartmentverano.png",
        },
        {
          link: "https://www.elsolution.hr",
          domain: "elsolution.hr",
          product: "El. Solution",
          shortdesc: "Elektroinstalacijske usluge - Rijeka",
          img: "elsolution.png",
        },
        {
          link: "https://www.vistanekretnine.hr",
          domain: "vistanekretnine.hr",
          product: "Vista Nekretnine d.o.o.",
          shortdesc: "Prodaja luksuznih stanova u Opatiji",
          img: "vistanekretnine.png",
        },
        {
          link: "https://www.studiotanya.hr",
          domain: "studiotanya.hr",
          product: "Studio Tanya Rijeka",
          shortdesc: "Obrt za njegu i masažu tijela",
          img: "studiotanya.png",
        },
        {
          link: "https://www.dizajn911.com",
          domain: "dizajn911.com",
          product: "Dizajn 911",
          shortdesc: "Studio za uređenje interijera | Katava",
          img: "dizajn911.png",
        },
        {
          link: "https://www.promo-tekstil.com",
          domain: "promo-tekstil.com",
          product: "Promo Tekstil",
          shortdesc: "Web shop | prodaja tekstilnih proizvoda",
          img: "promotekstil.png",
        },
        // {
        //   link: "https://www.apartmentselvira.com",
        //   domain: "apartmentselvira.com",
        //   product: "Apartmani Elvira",
        //   shortdesc: "Privatni smještaj u Brelima",
        //   img: "apartmentselvira.png",
        // },
        {
          link: "https://www.villamilibrela.com",
          domain: "villamilibrela.com",
          product: "Villa Mili Brela",
          shortdesc: "Apartmani",
          img: "villamilibrela.png",
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/portfolio.vue